import { store } from '@core/Store'
import { updateBetslipMaximized, updateUserData } from '@core/Areas/KambiClient/Store'

type ClientSubscriptions = Record<string, (response: WapiSubscriptionResponse) => void>

const clientSubscriptions: ClientSubscriptions = {
  BetslipMaximizedChange(response) {
    const isMaximized = response.data?.maximized
    if (isMaximized === undefined) return

    store.dispatch(updateBetslipMaximized(isMaximized))
  },
  UserData(response) {
    const { sessionId } = response.data
    if (sessionId === undefined) return

    store.dispatch(updateUserData(sessionId))
  },
}

export const handleClientSubscriptions = (response: WapiSubscriptionResponse): void => {
  clientSubscriptions[response.type]?.(response)
}
